export default __webpack_public_path__ + "static/media/errorbackground@2x.9b887594.png";